function baseLodash(){}module.exports=baseLodash;